<div class="summary">
  <coa-dashboard-summary-skeleton
    *ngIf="isLoading$ | async"
    class="summary__skeleton">
  </coa-dashboard-summary-skeleton>

  <div
    *ngIf="isError$ | async"
    class="summary__error">
    {{ 'Error while loading summary' | translate }}
  </div>

  <ng-container *ngIf="(isLoading$ | async) === false && (isError$ | async) === false">
    <div
      *ngIf="(dashboardSummary$ | async) == null"
      class="summary__no-data">
      {{ 'No data for summary' | translate }}
    </div>

    <div [ngClass]="{'summary-container--wide': (competitorsDefined$ | async) === false}" class="summary-container">
      <div
        *ngIf="(dashboardSummary$ | async)?.ownStores"
        class="summary__brand-summary-wrapper"
        data-cy="dashboard-summary.own-stores">
        <coa-brand-summary
          [borderColor]="'rgb(0, 145, 230)'"
          [brandName]="(dashboardSummary$ | async)?.clientName | translate"
          [clientId]="clientId"
          [paymentValue]="(dashboardSummary$ | async)?.ownStores.paymentConversion"
          [percentageValue]="(dashboardSummary$ | async)?.ownStores.changeInFootTraffic"
          [storeNumber]="(dashboardSummary$ | async)?.ownStores.numberOfStores"
          class="summary__brand-summary">
        </coa-brand-summary>
        <coa-list-element
          (click)="redirect(store.id)"
          *ngFor="let store of (dashboardSummary$ | async)?.ownStores?.items; let i = index"
          [chartLabel]="dateRange"
          [chartValue]="store.dailyStats | labelValue"
          [clientId]="clientId"
          [name]="store.name | translate"
          [number]="store.position"
          [percentageChangeLabel]="'Foot traffic' | translate"
          [percentageChangeValue]="store.changeInFootTraffic"
          [percentage]="store?.paymentConversion !== null && store?.paymentConversion !== undefined ? {label: 'Payment conversion' | translate, value: store?.paymentConversion} : null"
          [small]="competitorsDefined$ | async"
          [totalLabel]="'Traffic index' | translate"
          [totalValue]="store.trafficShare"
          class="list-element"
          data-cy="dashboard-summary.own-stores-list-element">
        </coa-list-element>

        <div class="centered">
          <coa-show-all (click)="showOwn()"></coa-show-all>
        </div>
      </div>
      <div
        *ngIf="competitorsDefined$ | async"
        class="summary__brand-summary-wrapper"
        data-cy="dashboard-summary.competitors">

        <coa-brand-summary
          [borderColor]="'rgb(157, 0, 230)'"
          [brandName]="'Competitor\'s Brands' | translate"
          [clientId]="clientId"
          [paymentValue]="(dashboardSummary$ | async)?.competitorStores.paymentConversion"
          [percentageValue]="(dashboardSummary$ | async)?.competitorStores?.changeInFootTraffic"
          [storeNumber]="(dashboardSummary$ | async)?.competitorStores?.numberOfStores"
          class="summary__brand-summary">
        </coa-brand-summary>

        <coa-list-element
          (click)="redirect(store.id)"
          *ngFor="let store of (dashboardSummary$ | async)?.competitorStores?.items; let i = index"
          [chartLabel]="dateRange"
          [chartValue]="store.dailyStats | labelValue"
          [clientId]="clientId"
          [name]="store.name | translate"
          [number]="store.position"
          [percentageChangeLabel]="'Foot traffic' | translate"
          [percentageChangeValue]="store?.changeInFootTraffic"
          [percentage]="store?.paymentConversion !== null ? {label: 'Payment conversion' | translate, value: store?.paymentConversion} : null"
          [small]="competitorsDefined$ | async"
          [totalLabel]="'Traffic index' | translate"
          [totalValue]="store.trafficShare"
          class="list-element"
          data-cy="dashboard-summary.competitors-list-element">
        </coa-list-element>

        <div class="centered">
          <coa-show-all
            (click)="showCompetitors()"
            data-cy="dashboard-summary.show-all-competitors"></coa-show-all>
        </div>
      </div>
    </div>
  </ng-container>
</div>
